/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers';
import type { Provider } from '@ethersproject/providers';
import type { ERC20Recovery, ERC20RecoveryInterface } from '../../FiatTokenV1.sol/ERC20Recovery';

const _abi = [
  {
    constant: true,
    inputs: [
      {
        name: 'account',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        name: '',
        type: 'uint256',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: 'to',
        type: 'address',
      },
      {
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export class ERC20Recovery__factory {
  static readonly abi = _abi;
  static createInterface(): ERC20RecoveryInterface {
    return new utils.Interface(_abi) as ERC20RecoveryInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC20Recovery {
    return new Contract(address, _abi, signerOrProvider) as ERC20Recovery;
  }
}
